import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getAllValues(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/ValoracionNumerico/GetAllData?descripcion=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getAllDataTableMax() {
  try {
    const response = await axios.get(
      "/ProcesosP/ValoracionNumerico/GetAllDataTableMax",
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getValoracionNumerico(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/ValoracionNumerico/Get",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertValoracionNumerico(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/ValoracionNumerico/Upsert",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
